export const lsGet = key => localStorage.getItem(key);

export const lsSet = (key, val) => localStorage.setItem(key, val);
